<template>
  <div>
    <a-drawer title="Shipping Template" :visible="dialogVisible" width="1000px" centered="true" @close="handleClose('ruleForm')" :destroyOnClose="true">
      <a-form-model layout="horizontal" ref="ruleForm" :model="ruleForm" :rules="rules" size="small" v-if="dialogVisible">
        <a-form-model-item label="Template Name" prop="name">
          <a-input v-model="ruleForm.name" class="withs" placeholder="Please enter template name" />
        </a-form-model-item>
        <a-form-model-item label="Billing Method" prop="type">
          <a-radio-group v-model="ruleForm.type" button-style="solid" @change="changeRadio(ruleForm.type)">
            <a-radio-button v-for="(item, index) in this.customDict.FreightTypeEnum" :value="item.type" :key="index">
              {{ translateDict(item.name) }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="Logistics Type" prop="logisticsType">
          <a-radio-group v-model="ruleForm.logisticsType" button-style="solid" >
            <a-radio-button v-for="(item, index) in this.customDict.LogisticsTypeEnum" :value="item.type" :key="index">
              {{ translateDict(item.name) }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="Default Template">
          <a-checkbox v-model="ruleForm.isDefault">Set as default template (applies to all products unless overridden)</a-checkbox>
        </a-form-model-item>
        <a-form-model-item label="Delivery Area & Freight"  prop="region">
          <a-table :columns="columns1" :data-source="ruleForm.region" :pagination="false"
                   :rowKey="(record,index)=>{return index}" class="tempBox">
            <div slot="areaInfos" slot-scope="text, record">
              <div class="custorhand" @click="editCity(1,record)">
                <template v-if="record.iSselect">
                  <div class="text-left text-bold">Global</div>
                </template>
                <template v-else>
                  <span class="text-left" v-for="(item, index) in record.areaInfos" :key="index">
                    <!-- 整省选中只展示省；部分城市选中展示省: 市1,市2 -->
                    <template v-if="!item.title">
                      <span class="text-bold">{{ item.province + ',' }}</span>
                    </template>
                    <span v-else>
                      <span class="text-bold">{{ item.province }}:</span>
                      <span class="padding-left-xs">{{ item.title }},</span>
                    </span>
                  </span>
                </template>
              </div>
            </div>
            <template slot="first" slot-scope="text, record">
              <a-form-model-item prop="first" class="margin-bottom-0">
                <a-input-number v-model="record.first" controls-position="right" :min="ruleForm.type === 1 ? 1 : 1" />
              </a-form-model-item>
            </template>
            <template slot="firstPrice" slot-scope="text, record">
              <a-form-model-item prop="firstPrice" class="margin-bottom-0">
                <a-input-number v-model="record.firstPrice" controls-position="right" :min="0" />
              </a-form-model-item>
            </template>
            <template slot="renewal" slot-scope="text, record" >
              <a-form-model-item prop="renewal" class="margin-bottom-0">
                <a-input-number v-model="record.renewal" controls-position="right"
                                :step-strictly="ruleForm.type === 1 ? true : false"
                                :min="ruleForm.type === 1 ? 1 : 1" />
              </a-form-model-item>
            </template>
            <template slot="renewalPrice" slot-scope="text, record">
              <a-form-model-item prop="renewalPrice" class="margin-bottom-0">
                <a-input-number v-model="record.renewalPrice" controls-position="right" :min="0" />
              </a-form-model-item>
            </template>
            <template slot="rule" slot-scope="text, record">
              <a href="javascript:void(0)" @click="openRuleEditor(record)">
                {{ (record.ruleList && record.ruleList.length) ? (record.ruleList.length + ' rule(s)') : 'Set rules' }}
              </a>
            </template>
            <template slot="action" slot-scope="text, record">
              <a href="javascript:void(0)" @click="confirmEdit(ruleForm.region, record, 1)" style="color:red;">Delete</a>
            </template>
          </a-table>
        </a-form-model-item>
        <a-form-model-item>
          <a-button style="margin-right: 10px" type="primary" size="small" @click="addCity(1)" v-show="!isSelectAllregion">
            <a-icon type="plus" />
            Add Delivery Area
          </a-button>
        </a-form-model-item>
        <a-form-model-item prop="sort" label="Sort">
          <a-input v-model="ruleForm.sort" class="withs" placeholder="Please enter sort" />
        </a-form-model-item>
        <a-form-model-item prop="remark" label="Remark">
          <a-input type="textarea" v-model="ruleForm.remark" />
        </a-form-model-item>
      </a-form-model>
      <div class="foot-btn">
        <a-button @click="handleClose" class="margin-right-sm">Cancel</a-button>
        <a-button type="primary"
                  :loading="loading"
                  @click="onsubmit('ruleForm')">OK
        </a-button>
      </div>
    </a-drawer>

    <!-- 按订单金额区间计费规则编辑器 -->
    <a-modal title="Amount Rules (by order amount)" v-model="ruleModalVisible" width="760px" @ok="saveRuleEditor">
      <a-table :columns="ruleColumns" :data-source="currentRuleList" :pagination="false" size="small" :rowKey="(r, i) => i">
        <template slot="minAmount" slot-scope="text, record, index">
          <a-input-number v-model="record.minAmount" :min="0" :precision="2" placeholder="Min" style="width:120px" />
        </template>
        <template slot="maxAmount" slot-scope="text, record">
          <a-input-number v-model="record.maxAmount" :min="0" :precision="2" placeholder="Max (blank=∞)" style="width:120px" />
        </template>
        <template slot="fee" slot-scope="text, record">
          <a-input-number v-model="record.fee" :min="0" :precision="2" placeholder="Fee" style="width:120px" />
        </template>
        <template slot="freeThreshold" slot-scope="text, record">
          <a-input-number v-model="record.freeThreshold" :min="0" :precision="2" placeholder="Free at (blank=none)" style="width:140px" />
        </template>
        <template slot="op" slot-scope="text, record, index">
          <a href="javascript:void(0)" style="color:red" @click="removeRuleRow(index)">Delete</a>
        </template>
      </a-table>
      <a-button type="dashed" block icon="plus" class="margin-top-sm" @click="addRuleRow">Add amount interval</a-button>
      <div class="margin-top-sm" style="color:#999;font-size:12px">
        Example: US orders $0–$50 → $5 fee; orders ≥ $100 → free shipping. Set Max blank for no upper bound.
      </div>
    </a-modal>

    <city ref="city" @selectCity="selectCity" :type="type" :id="curAddressId"
          :otherSelectedArr="otherSelectedArr"
          :selectArr="selectArr">
    </city>
  </div>
</template>

<script>
import * as logistics from '@/api/logistics'
import CustomDictTag from "@/components/DictCustomTag";
import city from './city.vue';
import { mapGetters } from 'vuex'
import { guid, resetForm } from '@/utils/ruoyi.js'

const defaultRole = {
  name: '',
  type: 1,
  shippingArea: null,
  logisticsType: 1,
  appoint: false,
  isDefault: false,
  sort: 0,
  remark:null,
  region: [],
}
const kg = 'Weight (kg)'
const m = 'Volume (m³)'
export default {
  name: 'CreatTemplates',
  components: {
    CustomDictTag,
    city
  },
  data() {
    return {
      loading: false,
      rules: {
        name: [
          { required: true, message: 'Please enter template name', trigger: 'blur' }
        ],
        shippingArea: [
          { required: true, message: 'Please select shipping location', trigger: 'change' }
        ],
        logisticsType: [
          { required: true, message: 'Please select logistics type', trigger: 'change' }
        ],
        type: [
          { required: true, message: 'Please select billing method', trigger: 'change' }
        ],
        region: [
          { required: true, message: 'Please add delivery area', trigger: 'change' }
        ],
      },
      nodeKey: 'city_id',
      props: {
        children: 'child',
        label: 'name',
        value: 'cityId',
        multiple: true
      },
      dialogVisible: false,
      ruleForm: Object.assign({}, defaultRole),
      listLoading: false,
      isSelectAllregion: false,
      isSelectAllfree: false,
      cityList: [],
      customColumn: [],
      tempId: 0,
      type: 0, // 0添加 1编辑
      addressModal: false,
      indeterminate: true,
      checkAll: false,
      checkAllGroup: [],
      activeCity: -1,
      provinceAllGroup: [],
      index: -1,
      displayData: '',
      currentProvince: '',
      selectArr: [], // 传递选中的城市
      curAddressId: 0,
      otherSelectedArr: [],
      // 金额区间规则编辑器
      ruleModalVisible: false,
      currentRuleIndex: -1,
      currentRuleList: [],
      ruleColumns: [
        { title: 'Min Amount', dataIndex: 'minAmount', scopedSlots: { customRender: 'minAmount' } },
        { title: 'Max Amount', dataIndex: 'maxAmount', scopedSlots: { customRender: 'maxAmount' } },
        { title: 'Fee ($)', dataIndex: 'fee', scopedSlots: { customRender: 'fee' } },
        { title: 'Free Threshold ($)', dataIndex: 'freeThreshold', scopedSlots: { customRender: 'freeThreshold' } },
        { title: 'Operation', dataIndex: 'op', scopedSlots: { customRender: 'op' } }
      ]
    }
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict','acityList']),
    columns1() {
      const areaCol = {
        width: 320,
        dataIndex: 'areaInfos',
        title: 'Deliverable Area',
        scopedSlots: { customRender: 'areaInfos' }
      }
      const actionCol = {
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' },
        title: 'Operation',
        width: 80
      }
      // 按订单金额：展示"金额区间规则"列
      if (this.ruleForm.type === 4) {
        return [areaCol, {
          dataIndex: 'rule',
          title: 'Amount Rules',
          scopedSlots: { customRender: 'rule' },
          width: 160
        }, actionCol]
      }
      const t = this.ruleForm.type
      const firstTitle = t === 2 ? `First ${kg}` : t === 3 ? `First ${m}` : 'First Item'
      const addTitle = t === 2 ? `Additional ${kg}` : t === 3 ? `Additional ${m}` : 'Additional Item'
      return [areaCol,
        { dataIndex: 'first', title: firstTitle, scopedSlots: { customRender: 'first' }, width: 130 },
        { dataIndex: 'firstPrice', title: 'Freight ($)', scopedSlots: { customRender: 'firstPrice' }, width: 120 },
        { dataIndex: 'renewal', title: addTitle, scopedSlots: { customRender: 'renewal' }, width: 120 },
        { dataIndex: 'renewalPrice', title: 'Renewal Fee ($)', scopedSlots: { customRender: 'renewalPrice' }, width: 120 },
        actionCol
      ]
    }
  },
  mounted() {
    this.ruleForm.appoint = true
  },

  methods: {
    /**
     * 清空文本框的值
     */
    clear() {
      this.tempId = ''
      this.isSelectAllfree = false
      this.isSelectAllregion = false
      this.loading = false
      defaultRole.region = []
      this.ruleForm = Object.assign({}, defaultRole)
    },
    // 将中文枚举名翻译为英文显示
    translateDict(name) {
      if (!name) return ''
      const map = {
        '快递': 'Express',
        '物流': 'Logistics',
        '按件数': 'By Quantity',
        '按重量': 'By Weight',
        '按订单金额': 'By Order Amount'
      }
      return map[name] || name
    },
    handleShow() {
      this.dialogVisible = true
    },
    handleClose(formName) {
      this.clear()
      this.dialogVisible = false
      this.loading = false
    },

    /**获取某个省下面的市的个数 */
    getAreaNum(cityId) {
      let num = 0
      this.acityList.forEach((item,index)=>{
        if(item.areaId == cityId) {
          num = item.children.length
        }
      })
      return num
    },

    /**
     * 获取运费模板详情
     */
    getInfo(options) {
      options && (this.tempId = options.id)
      this.ruleForm = Object.assign({}, defaultRole)
      logistics.templateDetailApi({ id: this.tempId }).then(res => {
        if(res.success) {
          let regionList = res.data.regionList
          if(regionList.length) {
            regionList.forEach((item,index)=>{
              let selectedCityNum = 0
              if(!item.id) item.id = guid(8,10)
              item.data = []
              item.ruleList = item.ruleList || []
              item.areaInfos.forEach((item1,index1)=>{
                let obj = {
                  "areaName": item1.province,
                  "areaId": item1.provinceId
                }
                item.data.push(obj)
              })
              selectedCityNum = item.areaInfos.length
              if (selectedCityNum >= this.acityList.length) {
                regionList.forEach((item,index)=>{
                  item.iSselect =true
                })
              }
            })
            this.setBtnShow(regionList, 'isSelectAllregion')
          }
          this.ruleForm = Object.assign(this.ruleForm, {
            name: res.data.name,
            type: res.data.type,
            shippingArea: res.data.shippingArea,
            logisticsType: res.data.logisticsType,
            appoint: res.data.appoint,
            isDefault: res.data.isDefault || false,
            sort: res.data.sort,
            remark: res.data.remark,
            region: regionList,
          })
          this.dialogVisible = true
        }
      }).catch(res => {
        this.$message.error(res.message)
      })
    },
    /**
     * 切换计费方式（列随类型变化，由 computed columns1 处理）
     */
    changeRadio() {
      this.$forceUpdate()
    },
    changeDelivertype(e) {
      this.ruleForm.appoint = e.target.value
    },
    changType(type) {
      this.type = type
      this.ruleForm.type = type
    },

    /**添加配送区域 */
    addCity(type) {
      this.selectArr = []
      this.type = type;
      this.otherSelectedArr = []
      if(type == 1) {
        this.ruleForm.region.forEach((item, index)=>{
          this.otherSelectedArr.push(...item.data)
        })
      }
      this.$refs.city.empty()
      this.$refs.city.addressModal = true;
    },
    /**
     * 编辑城市区域弹窗
     */
    editCity(type, record) {
      this.type = type;
      this.curAddressId = record.id
      this.selectArr = record.data
      this.otherSelectedArr = []
      if(type == 1) {
        this.ruleForm.region.forEach((item, index)=>{
          if(item.id != record.id) {
            this.otherSelectedArr.push(...item.data)
          }
        })
      }
      this.$refs.city.empty()
      this.$refs.city.addressModal = true;
    },
    /**选择城市后处理数据 */
    selectCity(obj) {
      let data = obj.selectList, type = obj.type, iSselect = obj.iSselect, editedIndex = -1
      if(obj.isEdit) {
        if(obj.type == 1) {
          editedIndex = this.ruleForm.region.findIndex(item=>{return item.id == obj.id})
        }
      }
      let areaInfos = []
      data.forEach(item => {
        let aobj = {
          provinceId: item.areaId,
          province: item.areaName,
          title: item.cityNames || '',
          cityIds: item.cityIds || '',
        }
        areaInfos.push(aobj)
      })
      switch (type) {
        case 1:
          if(obj.isEdit) {
            let flag = iSselect
            this.$set(this.ruleForm.region[editedIndex], 'areaInfos', areaInfos)
            this.$set(this.ruleForm.region[editedIndex], 'data', obj.selectList)
            this.$set(this.ruleForm.region[editedIndex], 'iSselect', flag)
          }else{
            this.ruleForm.region.push({
              id: guid(8,10),
              iSselect: iSselect,
              areaInfos: areaInfos,
              first: 1,
              firstPrice: 0,
              renewal: 1,
              renewalPrice: 0,
              ruleList: [],
              data: obj.selectList
            });
          }
          break;
      }
    },
    /**控制 添加城市按钮 显示隐藏 */
    setBtnShow(arr, iSselect, fieldname) {
       iSselect ? this[fieldname] = true : this[fieldname] = false
    },
    /**删除所选城市 */
    confirmEdit(areaArr, record, type) {
      let delIndex = areaArr.findIndex(item=>{return item.id == record.id})
      areaArr.splice(delIndex, 1)
    },

    /* ===== 按订单金额区间规则编辑器 ===== */
    openRuleEditor(record) {
      this.currentRuleIndex = this.ruleForm.region.indexOf(record)
      this.currentRuleList = (record.ruleList || []).map(r => ({
        minAmount: r.minAmount,
        maxAmount: r.maxAmount,
        fee: r.fee,
        freeThreshold: r.freeThreshold
      }))
      this.ruleModalVisible = true
    },
    addRuleRow() {
      this.currentRuleList.push({ minAmount: 0, maxAmount: null, fee: 0, freeThreshold: null })
    },
    removeRuleRow(idx) {
      this.currentRuleList.splice(idx, 1)
    },
    saveRuleEditor() {
      if (this.currentRuleIndex > -1) {
        this.$set(this.ruleForm.region[this.currentRuleIndex], 'ruleList', this.currentRuleList)
      }
      this.ruleModalVisible = false
    },

    onsubmit: (function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          let obj = JSON.parse(JSON.stringify(this.ruleForm))
          obj.region.forEach((item,index)=>{
            delete item.data
            // 非"按订单金额"类型不发送金额区间规则
            if (this.ruleForm.type !== 4) {
              delete item.ruleList
            }
          })
          const param = {
            appoint: this.ruleForm.appoint,
            name: this.ruleForm.name,
            sort: this.ruleForm.sort,
            type: this.ruleForm.type,
            isDefault: this.ruleForm.isDefault,
            shippingArea: this.ruleForm.shippingArea,
            logisticsType: this.ruleForm.logisticsType,
            remark: this.ruleForm.remark,
            regionList: obj.region,
          }

          if (this.tempId) {
            param.id = this.tempId
            logistics.shippingUpdate(param).then(res => {
              if (res.success) {
                this.$message.success('Operation successful')
                this.handleClose()
                this.$nextTick(() => {
                  this.dialogVisible = false
                  this.ruleForm = {}
                })
                setTimeout(() => {
                  this.$emit('getList')
                }, 600)
              }else{
                this.$message.error(res.message);
              }
              this.loading = false;
            })
          } else {
            logistics.shippingSave(param).then(response => {
              if (response.success) {
                this.$message.success('Added successfully')
                setTimeout(() => {
                  this.$emit('getList')
                  this.handleClose()
                }, 600)
                this.$nextTick(() => {
                  this.dialogVisible = false
                  this.ruleForm = {}
                })
              } else {
                this.$message.error(response.message);
              }
              this.loading = false
            })
          }
        } else {
          return false
        }
      })
    })
  }
}
</script>

<style scoped lang="less">
.withs {
  width: 50%;
}

.tempBox {
  ::v-deep.a-input-number--mini {
    width: 100px !important;
  }
}

.custorhand {
  cursor: pointer;
}

.margin-bottom-0 {
  margin-bottom: 0!important;
}

.margin-top-sm {
  margin-top: 12px;
}
</style>
